export default function Noop() {
  return <div style={{ display: "none" }} />;
}
